import React from 'react';
import PropTypes from 'prop-types';
import { Col, Panel, Row } from 'react-bootstrap';
import s from '../login/Login.module.css';
import ss from './GenericErrorPage.module.css';
import Link from '../../components/Link';

import logo from '../../common/images/logo_full.png';

const GenericErrorPage = ({ error }, context) => {
  const { content, pageTitle, title } = error;

  if (context.setTitle) {
    context.setTitle(pageTitle);
  }

  const header = (
    <Row>
      <Col sm={6} smOffset={3}>
        <Link to="/" className="hvr-pulse-grow">
          <img src={logo} alt="logo" className="user-avatar img-responsive" />
        </Link>
      </Col>
    </Row>
  );

  return (
    <div className={` animate ${s.loginPage} ${ss.genericErrorPage}`}>
      <div className="row">
        <div className="col-md-4 col-lg-4 col-md-offset-4 col-lg-offset-4">
          <Panel className={`box ${s.box}`}>
            <Panel.Heading>{header}</Panel.Heading>
            <Panel.Body>
              <h1>Portail partenaire Tikeasy</h1>
              <div>
                <p className={ss.errorBlock}>
                  <b>{title}</b>
                </p>
                <p className={ss.errorBlock}>{content}</p>
              </div>
            </Panel.Body>
          </Panel>
        </div>
      </div>
    </div>
  );
};

GenericErrorPage.propTypes = { error: PropTypes.object.isRequired };
GenericErrorPage.contextTypes = { setTitle: PropTypes.func.isRequired };

export { GenericErrorPage as GenericErrorPageWithoutStyle };
export default GenericErrorPage;
